import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUserProductListItemLightweight, dataToAddProduct } from '~/types/api/AidKit'
import s from '~/utils/s'
import ProductAddOrDel from '~/assets/svg/product-add-or-del.svg?inline'
import NotificationType from '~/types/enum/NotificationType'

@Component
export default class UserListItem extends Vue {
  @Prop({ required: true, type: String })
  readonly productId!: string;

  @Prop({ required: true, type: String })
  readonly userProductListId!: string;

  @Prop({ required: true, type: String })
  readonly userListName!: string;

  deleteOrAddToUserList (action: string, userProductListId: string) {
    const data: dataToAddProduct = { productId: this.productId, userProductListId, route: this.$route }
    const currentList = s(this.$store).userProductList.userProductLists.find(upl => upl.id === userProductListId)?.items.length ?? 0
    if (action === 'add') {
      if (currentList <= 29) {
        s(this.$store).userProductList.addToUserProductList(data)
      } else {
        s(this.$store).notification.addNotification({
          type: NotificationType.Error,
          text: 'Максимальное количество товара в списке - 30'
        })
      }
    } else {
      const currentListData = s(this.$store).userProductList.userProductLists.find(upl => upl.id === userProductListId)
      const item = currentListData?.items.find((item: IUserProductListItemLightweight) => item.productId === this.productId)
      s(this.$store).userProductList.removeItemFromUserProductList({ productId: item?.productId!, userProductListId, route: this.$route })
    }
  }

  checkProductInList (data: dataToAddProduct) {
    const lists = s(this.$store).userProductList.userProductLists.map((upl) => {
      if (upl.id === data.userProductListId) {
        const list = upl.items.map((item: IUserProductListItemLightweight) => { return item.productId })
        if (list.includes(data.productId)) {
          return true
        } else {
          return false
        }
      }
    })
    if (lists.includes(true)) {
      return true
    } else {
      return false
    }
  }

  render () {
    const includesProduct = this.checkProductInList({ productId: this.productId, userProductListId: this.userProductListId })
    return (
      <div{...{
        class: {
          'user-list-small-item': true,
          'user-list-small-item-active': includesProduct
        }
      }} >
        {this.userListName}
        {includesProduct &&
              <div {...{
                class: 'user-list-small-item-action',
                on: {
                  click: (event: MouseEvent) => {
                    event.preventDefault()
                    this.deleteOrAddToUserList('del', this.userProductListId)
                  }
                }
              }} >
                <div class="user-list-small-item-action-del">
                  <ProductAddOrDel/>
                </div>
              </div>}
        {!includesProduct &&
              <div {...{
                class: 'user-list-small-item-action',
                on: {
                  click: (event: MouseEvent) => {
                    event.preventDefault()
                    this.deleteOrAddToUserList('add', this.userProductListId)
                  }
                }
              }} >
                <div class="user-list-small-item-action-add">
                  <ProductAddOrDel/>
                </div>
              </div>}
      </div>
    )
  }
}
